import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub, BsChevronLeft, BsChevronRight } from "react-icons/bs";

function ProjectCards(props) {
  const images = props.images || (props.imgPath ? [props.imgPath] : []);
  const [idx, setIdx] = useState(0);

  const prev = (e) => {
    e.stopPropagation();
    setIdx((i) => (i - 1 + images.length) % images.length);
  };
  const next = (e) => {
    e.stopPropagation();
    setIdx((i) => (i + 1) % images.length);
  };

  return (
    <Card className="project-card-view">
      <div className="project-img-wrapper">
        <Card.Img variant="top" src={images[idx]} alt="card-img" className="project-card-img" />
        {images.length > 1 && (
          <>
            <button className="carousel-btn carousel-btn-left" onClick={prev} aria-label="Previous">
              <BsChevronLeft />
            </button>
            <button className="carousel-btn carousel-btn-right" onClick={next} aria-label="Next">
              <BsChevronRight />
            </button>
            <div className="carousel-dots">
              {images.map((_, i) => (
                <span
                  key={i}
                  className={`carousel-dot ${i === idx ? "active" : ""}`}
                  onClick={(e) => { e.stopPropagation(); setIdx(i); }}
                />
              ))}
            </div>
          </>
        )}
      </div>

      <Card.Body style={{ display: "flex", flexDirection: "column" }}>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify", flexGrow: 1 }}>
          {props.description}
        </Card.Text>

        {props.techStack && props.techStack.length > 0 && (
          <div className="project-tech-stack">
            {props.techStack.map((tech) => (
              <span key={tech} className="project-tech-badge">{tech}</span>
            ))}
          </div>
        )}

        <div style={{ marginTop: "12px" }}>
          {props.ghLink && (
            <Button variant="primary" href={props.ghLink} target="_blank">
              <BsGithub /> &nbsp;GitHub
            </Button>
          )}
          {!props.isBlog && props.demoLink && (
            <Button
              variant="primary"
              href={props.demoLink}
              target="_blank"
              style={{ marginLeft: props.ghLink ? "10px" : "0" }}
            >
              <CgWebsite /> &nbsp;Live Demo
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
